var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16.892,
    viewBox: "0 0 16 16.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Broken_Home",
    "data-name": "Iconly/Broken/Home",
    transform: "translate(-18.5 -2.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(18.5 2.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136726",
    "data-name": "Path 136726",
    d: "M1.7,4.279a.666.666,0,0,1,.682,1.093h0l-.6.444a1.251,1.251,0,0,0-.452.955h0v6.775a2.014,2.014,0,0,0,2.006,2H6.745v.015a.666.666,0,0,1,0,1.333H3.339A3.347,3.347,0,0,1,0,13.553H0V6.771a2.577,2.577,0,0,1,1-2H1l.615-.459ZM6.064.678a3.073,3.073,0,0,1,3.85,0h0l5.116,4.08a2.6,2.6,0,0,1,.97,2h0l-.007,6.789a3.339,3.339,0,0,1-3.339,3.339H11.173a1.621,1.621,0,0,1-1.621-1.614h0V12.206l-.007-.077a.43.43,0,0,0-.423-.352H6.9a.429.429,0,0,0-.429.437h0v1.17a.666.666,0,0,1-1.333,0h0v-1.17a1.77,1.77,0,0,1,1.77-1.77H9.129a1.77,1.77,0,0,1,1.762,1.77h0v3.058a.281.281,0,0,0,.281.281H12.69a2,2,0,0,0,2-2h0V6.771a1.251,1.251,0,0,0-.474-.963h0L9.1,1.729a1.747,1.747,0,0,0-2.221,0h0L5.235,2.958a.679.679,0,1,1-.792-1.1h0Z",
    transform: "translate(0 0)",
    fill: "#fdfdfd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.5e7f47c12898493ad5c0b589765e6da6.svg";
export { ForwardRef as ReactComponent };